import { render, staticRenderFns } from "./B2CReportV2.vue?vue&type=template&id=37a47690&scoped=true&"
import script from "./B2CReportV2.vue?vue&type=script&lang=js&"
export * from "./B2CReportV2.vue?vue&type=script&lang=js&"
import style0 from "./B2CReportV2.vue?vue&type=style&index=0&id=37a47690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a47690",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAlert,VCol,VRow,VSelect,VSnackbar,VSpacer,VTab,VTabItem,VTabs,VTabsItems})
